import { render, staticRenderFns } from "./DataImportLogs.vue?vue&type=template&id=7bbe487a"
import script from "./DataImportLogs.vue?vue&type=script&lang=js"
export * from "./DataImportLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports